import { mockDataAgent } from '../agents';
import { mockConversations } from '../conversations';
import { makeStreamStart, makeBlockStart, makeBlockEnd, makeBlockComplete, makeStreamEnd, splitTextIntoDeltas } from '../sseEvents';
const RESPONSE_ID = 'resp-load-timeout';
const CONV_ID = 'conv-7';
const MD_BLOCK_ID = 'blk-lt-md';
const LOADING_BLOCK_ID = 'blk-lt-loading';
const CALLOUT_BLOCK_ID = 'blk-lt-callout';
const TIMEOUT_BLOCK_ID = 'blk-lt-timeout';
const markdownText = 'I tried running your query but it took too long. Here is what happened:';
const loadingBlock = {
    type: 'loading',
    block_id: LOADING_BLOCK_ID,
    block_index: 1,
    agent: mockDataAgent,
    message: 'Running complex analysis across all buildings...',
    phase: 'long_running',
    elapsed_ms: 28000
};
const calloutBlock = {
    type: 'callout',
    block_id: CALLOUT_BLOCK_ID,
    block_index: 2,
    variant: 'warning',
    title: 'Performance Warning',
    content: 'Queries spanning more than 2 years of data may exceed the processing limit.',
    dismissible: true
};
const timeoutBlock = {
    type: 'timeout',
    block_id: TIMEOUT_BLOCK_ID,
    block_index: 3,
    original_query: 'Show all inspection history with full deficiency details for every building',
    suggested_query: 'Show inspection summary for the last 6 months',
    retry_count: 1,
    max_retries: 3,
    actions: []
};
const sseSequence = [
    makeStreamStart(RESPONSE_ID, CONV_ID, mockDataAgent),
    makeBlockStart(MD_BLOCK_ID, 0, 'markdown'),
    ...splitTextIntoDeltas(MD_BLOCK_ID, markdownText, 14, 50),
    makeBlockEnd(MD_BLOCK_ID),
    makeBlockComplete(loadingBlock, 1500),
    makeBlockComplete(calloutBlock, 300),
    makeBlockComplete(timeoutBlock, 400),
    makeStreamEnd(RESPONSE_ID, 4, mockDataAgent)
];
export const scenario = {
    name: 'Data Assistant — Loading & Timeout',
    description: 'Timeout scenario showing Loading state, warning Callout, and Timeout block with retry suggestion.',
    conversations: mockConversations,
    userMessage: 'Show all inspection history with full deficiency details for every building',
    agentIdentity: mockDataAgent,
    sseSequence
};
